var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},_vm._l((_vm.len),function(item){return _c('van-skeleton',{key:item,attrs:{"row":_vm.row}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }